import React, { Component } from 'react';
import {Table, message, Input, Button, Form, Popconfirm, Popover, Icon, Menu, Dropdown } from 'antd';
import { deleteRole, getRoleList } from '../../apis/api'
import '../../static/css/index.css'

import EditRole from './components/editRole.js'
import RolePrivilege from './components/rolePrivilege.js'
import RoleUser from './components/roleUser.js'
import RoleJob from './components/roleJob.js'

import moment from 'moment';

class Role extends Component {
  constructor(props) {
    super(props);
    this.state={
        access_token:'',
        search_params:{},
        flag:false,
        roleList:[],
        currentPage:1,
        currentPageSize:10,
        total:0,
        edit_role_visible:false,//添加修改角色modal是否打开
        details:{},
        role_privilege_visible:false,//角色权限modal是否打开
        role_privilege_uuid:'',
        role_user_visible:false,//按员工授权modal是否打开
        role_user_uuid:'',
        role_name:'',
        role_job_visible:false,//按岗位授权modal是否打开
        role_job_uuid:'',
    }
  }

  componentDidMount(){

    this.setState({access_token:sessionStorage.getItem('access_token')},()=>{

        this.getRoleList();

    })
    
  }

  getRoleList = (obj) =>{
    let _this=this;
    this.setState({flag:true})
    const { access_token, currentPage, currentPageSize } = this.state;
    let params={
        access_token:access_token,
        name:obj&&obj.name?obj.name:'',
        page:currentPage,
        page_size:currentPageSize
    }
    getRoleList(params).then( (data)=> {

        if(data.code === 0){

            let roleList=data.content.list;
            let total=data.content.paging.total_record;
            _this.setState({ roleList, total, flag:false })

        }else{

            message.error(data.message); 
        }
    });

  }

  //添加角色
  addRole = ()=>{
    this.setState({
        edit_role_visible:true,
        details:{}
    });
  }

  //更新角色
  updateRole(obj){
    this.setState({
        edit_role_visible:true,
        details:obj
    });
    
  }

  
  // 删除角色
  deleteRole(id){
    let _this=this;
    let params={
        access_token:_this.state.access_token,
        id:id,
    }
    deleteRole(params).then( (data)=> {
        if(data.code===0){
            message.success('删除角色成功！');
            _this.setState({currentPage:1},()=>{
                _this.getRoleList(_this.state.search_params);
            })
        }else{
            message.error(data.message);
      }
    });
    
  }

  // 角色权限
  rolePrivilege(uuid){

    this.setState({role_privilege_visible:true,role_privilege_uuid:uuid});

  }

  // 按员工授权
  roleUser(record){

    this.setState({role_user_visible:true,role_user_uuid:record.uuid,role_name:record.name});

  }

  //按岗位授权
  roleJob(record){

    this.setState({role_job_visible:true,role_job_uuid:record.uuid,role_name:record.name});

  }

  // 关闭弹窗
  handleCancel = (e) => {
    this.setState({
        edit_role_visible:false,
        details:{},
        role_privilege_visible:false,
        // role_privilege_uuid:'',//点击相同角色权限时，可不重新加载数据
        role_user_visible:false,
        role_job_visible:false,
        // role_user_uuid:'',
        // role_name:''
        // role_job_uuid:''
    });
  }

  //页码变化
  handleTableChange = pagination => {
    var _this = this;
    const current = pagination.current || 1;
    this.setState({ currentPage: current },()=>{
        _this.getRoleList(_this.state.search_params);
    });
  }
  
  //搜索
  searchRole = () =>{
    let _this=this;
    _this.props.form.validateFields((err, values) => {
      if(err) {
          console.log('submit error:' ,err);
      }else {
        _this.setState({currentPage:1,search_params:values},()=>{
            _this.getRoleList(values);
        })
      }
    });
  }

    //新增编辑之后加载表格数据
    reloadSearchRole = () =>{
        this.getRoleList(this.state.search_params);
    }

  render() {
    const { getFieldDecorator } = this.props.form;
    const {currentPage, curPageSize, total, roleList, flag, edit_role_visible, details, role_privilege_visible, role_privilege_uuid, role_user_visible, role_user_uuid, role_name, role_job_visible, role_job_uuid} = this.state;

    const columns = [{
      title: '序号',
      dataIndex: '',
      width:'60px',
      align:'center',
      render:(text, record, index) => (<span>{index+1}</span>)
    }, {
      title: '角色名称',
      dataIndex: 'name',
      width:'120px',
      align:'center',
    }, {
        title: '是否为管理员',
        dataIndex: 'is_manage',
        width:'80px',
        align:'center',
        render:text =><span>
            {text===1?'是':''}
            {text===2?'否':''}
        </span>
    }, {
        title: '角色说明',
        dataIndex: 'desc',
        width:'120px',
        align:'center',
    }, {
        title: '创建人',
        dataIndex: 'create_user',
        width:'120px',
        align:'center',
    },{
      title: '创建时间',
      dataIndex: 'created_at',
      width:'120px',
      align:'center',
      render:text => (<span>{text?moment.unix(parseInt(text)).format("YYYY-MM-DD HH:mm:ss"):''}</span>)
    },{
      title: '更新时间',
      dataIndex: 'updated_at',
      width:'120px',
      align:'center',
      render:text => (<span>{text?moment.unix(parseInt(text)).format("YYYY-MM-DD HH:mm:ss"):''}</span>)
      },{
      title: '操作',
      dataIndex: 'operation',
      width:'200px',
      align:'center',
    //   render:(text, record,index) => (<div>
    //      <a style={{marginRight:10}} onClick={this.rolePrivilege.bind(this,record.uuid)}>权限</a>
    //      <a style={{marginRight:10}} onClick={this.roleUser.bind(this,record)}>授权</a>
    //      <Popover content={content} placement='bottom'>
    //            <a className="ant-dropdown-link">
    //              授权 <Icon type="down" />
    //            </a>
    //      </Popover>
    //      <a style={{marginRight:10}} onClick={this.updateRole.bind(this,record)}>更新</a>
    //      <Popconfirm title="确认删除角色吗?" okText="确认" cancelText="取消" onConfirm={()=>this.deleteRole(record.id)} onCancel={()=>{}}>
    //         <a>删除</a>
    //      </Popconfirm>
    //   </div>)
      render:(text, record,index) => {
        const menu = (
            <Menu>
              <Menu.Item>
                  <a style={{color:'#1890ff'}} onClick={this.roleUser.bind(this,record)}>按员工授权</a>
              </Menu.Item>
              <Menu.Item>
                  <a style={{color:'#1890ff'}} onClick={this.roleJob.bind(this,record)}>按岗位授权</a>
              </Menu.Item>
            </Menu>
          );
        return <span>
            <a style={{marginRight:10}} onClick={this.rolePrivilege.bind(this,record.uuid)}>权限</a>
            <Dropdown overlay={menu}>
               <a style={{marginRight:10}} onClick={e => e.preventDefault()}>
               授权 <Icon type="down" />
               </a>
            </Dropdown>
            <a style={{marginRight:10}} onClick={this.updateRole.bind(this,record)}>更新</a>
            <Popconfirm title="确认删除角色吗?" okText="确认" cancelText="取消" onConfirm={()=>this.deleteRole(record.id)} onCancel={()=>{}}>
              <a>删除</a>
            </Popconfirm>
          
         </span>
      }
    }];

    return (
      <div className='layout_content_wrapper'>

       <div className='search_form'>
            <Form layout="inline">
                <Form.Item label="角色名称">
                    {getFieldDecorator('name', {
                        initialValue:''
                    })(
                        <Input placeholder='角色名称' style={{width:200}} onPressEnter={this.searchRole} />
                    )}
                </Form.Item>

                <Form.Item>
                   <Button type='primary' onClick={this.searchRole}>搜索</Button>
                </Form.Item>
            </Form>
      </div>

      <div className="add_btn"><Button type="primary" onClick={this.addRole}>添加角色</Button></div>

      <div className="layout_content_table">
                <Table rowKey='id' scroll={{ x:940 }} columns={columns} dataSource={roleList} loading={flag} 
                       pagination={{
                            current: currentPage,
                            pageSize: curPageSize,
                            total: total
                       }}
                        onChange={this.handleTableChange}/>
      </div>

      {/* 添加、更新角色 */}
      <EditRole  visible={edit_role_visible} details={details} cancelModal={this.handleCancel} getRoleList={this.reloadSearchRole} />

      {/* 角色权限 */}
      {role_privilege_visible?<RolePrivilege visible={role_privilege_visible} role_uuid={role_privilege_uuid} cancelModal={this.handleCancel} />:''}

      {/* 按员工授权 */}
      <RoleUser visible={role_user_visible} role_uuid={role_user_uuid} role_name={role_name} cancelModal={this.handleCancel} />

      {/* 按岗位授权 */}
      <RoleJob visible={role_job_visible} role_uuid={role_job_uuid} role_name={role_name} cancelModal={this.handleCancel} />

     </div>
    );
  }
}

Role = Form.create({
   
})(Role);
export default Role;



// WEBPACK FOOTER //
// ./src/page/Privilege/Role.js